export default __webpack_public_path__ + "static/media/ic_pin_drop.3afab6d4.svg";